import React, { useState } from 'react';

const Support = () => {
  const [email, setEmail] = useState('');
  const [question, setQuestion] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log(`Email: ${email}, Question: ${question}`);
    alert('Your question has been sent! We will get back to you soon.');
    // Reset form
    setEmail('');
    setQuestion('');
  };

  return (
    <div style={styles.container}>
      <h1 style={styles.header}>Vasco App Support</h1>
      <p>If you have any questions or need support, feel free to reach out to us.</p>
      <form onSubmit={handleSubmit} style={styles.form}>
        <input
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="Your email"
          style={styles.input}
          required
        />
        <textarea
          value={question}
          onChange={(e) => setQuestion(e.target.value)}
          placeholder="Your question"
          style={styles.textarea}
          required
        />
        <button type="submit" style={styles.button}>Send Question</button>
      </form>
    </div>
  );
};

const styles = {
  container: {
    textAlign: 'center',
    padding: '50px',
  },
  header: {
    fontSize: '2em',
    color: '#333',
  },
  form: {
    margin: 'auto',
    maxWidth: '500px',
  },
  input: {
    width: '100%',
    padding: '10px',
    marginBottom: '10px',
    borderRadius: '5px',
    border: '1px solid #ddd',
  },
  textarea: {
    width: '100%',
    height: '150px',
    padding: '10px',
    marginBottom: '10px',
    borderRadius: '5px',
    border: '1px solid #ddd',
    resize: 'vertical',
  },
  button: {
    width: '100%',
    padding: '10px',
    borderRadius: '5px',
    border: 'none',
    backgroundColor: '#FFC300',
    color: 'white',
    fontSize: '16px',
    cursor: 'pointer',
  }
};

export default Support
